export default __webpack_public_path__ + "static/BasierCircle-Italic-14d030514f00dedc58bb0a711062d7ba.woff2";